// import { Autocomplete, Grid, TextField, Typography } from "@mui/material";
// import React, { memo, useEffect, useState } from "react";
// import { useStyle } from "../style";
// import axios from "axios";
// import moment from "moment";
// import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import dayjs from "dayjs";
// import { useDispatch } from "react-redux";
// import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";

// const SalesInfo = ({setPostData,postData, docName, setDocName}) => {
//   const classes = useStyle();
//   const[supplierData,setSupplierData]=useState([])
//   const [address , setAddress] = useState("")
//   const [gstIn , setGstIn] = useState("")
//   const [mode, setMode] = useState("")
//   const [balance , setBalance] = useState("0.00")
//   const outletId = localStorage.getItem("outlet_id")
//   const dispatch = useDispatch()
//   const [poDetails , setPoDetails] = useState({
//     docDate:moment().format(),
//     supplierId:null
//   })
//   const getSupplierData = () => {
//     axios.get(`/v1/outlet/list/1`)
//     .then((res) => {
//       setSupplierData(res.data)
//     })
//     .catch((err) => {console.log(err);dispatch(setSnackbar(true,'error',err.response.data.error))})
//   }

//   const handleSupplierChange = (event, value) => {
//     // formik.setFieldValue("supplier" , value)

//     const selectedSupplier = supplierData.find((supplier) => supplier.fullname === value?.fullname);
//     console.log(selectedSupplier)
//     setAddress(selectedSupplier ? (selectedSupplier.add1 + " " + selectedSupplier.add2 + "," + selectedSupplier.city_name + "-" + selectedSupplier.pincode + "-" + selectedSupplier.state_name + "-" + selectedSupplier.country_name) : ''); // Update this based on your actual data structure
//     setGstIn(selectedSupplier ? selectedSupplier.gstin : "")
//     setBalance(selectedSupplier ? selectedSupplier.balance  :"0.00")
//     setPoDetails((prevState) =>( {...prevState , supplierId:value}))  
//     setMode(value.outlet_type_name === "OWN" ? 'Transfer' : 'Sales')
//   };
//   const handleChange =(e) => {
//     console.log( dayjs(e).format())
//     setPoDetails((prevState) =>( {...prevState , docDate :  dayjs(e).format() }))
// }
//   useEffect(() => {
//     getSupplierData() // suplier name

//     const postData = {
//       outlet_id : outletId,
  
//     }
//     axios.post('/v1/sales_master/unique/docno/new',postData)
//     // axios.get('/v1/sales_master')
//     .then(res=>{
//       setDocName(res.data.Docno)
//     }).catch(err=>{
//       console.log(err.response.data)
//       dispatch(setSnackbar(true,'error',err.response.data.error))
//     })
//   },[])
  
// useEffect(()=>{
//   console.log(poDetails.docDate)
// if(poDetails.supplierId!==null){
//   setPostData((prev)=>({...prev, docdate : moment(poDetails.docDate).format('YYYY/MM/DD'), mode: mode, partycode : poDetails.supplierId.id}))
// }
// },[poDetails])
// console.log(poDetails)
//   return (
//     <Grid container spacing={2} className="p-2 h-full" >
//               <Grid item lg={4} >
//         <Autocomplete
//           id="supplier"
//           name="supplier"
//           size="small"
//           options={supplierData}
//           getOptionLabel={(option) => option?.fullname}
//           value={poDetails.supplierId}
//           onChange={handleSupplierChange}
//           disableClearable
//           isOptionEqualToValue={(option, value) =>
//             option.fullname === value.fullname
//           }
//           renderInput={(params) => (
//             <TextField
//               {...params}
//               label="Outlet Name"
//               autoComplete="off"
//               // required
//             />
//           )}
//   />
//         <TextField size="small" label='Address'  multiline rows={3.3} fullWidth sx={{marginBlock:1.5}} value={address} InputProps={{ readOnly: true }}/>
//         <TextField size="small" label='GSTIN' fullWidth  value={gstIn} InputProps={{ readOnly: true }}/>

//         </Grid>
//         <Grid item lg={4}>
//         <TextField size="small" label='Bill No' fullWidth  value={docName} InputProps={{ readOnly: true }}/>
            
//              <LocalizationProvider dateAdapter={AdapterDayjs}>
//           <DatePicker onChange={(e)=>handleChange(e)} value={dayjs(poDetails.docDate)} label="Bill Date" 
//             slotProps={{
//                   textField: {
//                     size: "small",
//                   },
//                 }}
//                 sx={{width: '100%',marginBlock:1.5}}
//                 />
//         </LocalizationProvider>

//         <TextField size="small" label='Mode' fullWidth sx={{marginBlock:1.5}} value={mode}/>
       
//         </Grid>
//    <Grid item lg={4}>
//         <Typography textAlign="center" variant="h6" sx={{backgroundColor:'#83A2FF',}}>Balance</Typography>
//         <Typography textAlign='right' variant="h5" mt={1} sx={{fontWeight:600,}}>{balance}</Typography>
//    </Grid>
//     </Grid>
//   );
// };

// export default memo(SalesInfo);

import { Autocomplete, Grid, TextField, Typography } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import { useStyle } from "../style";
import axios from "axios";
import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import _ from "lodash";

const SalesInfo = ({ outletType, setOutletType, salesMargin,setSalesMargin,setPostData, postData, docName, setDocName ,data}) => {
  const classes = useStyle();
  const [supplierData, setSupplierData] = useState([]);
  const [address, setAddress] = useState("");
  const [gstIn, setGstIn] = useState("");
  const [mode, setMode] = useState("");
  const [balance, setBalance] = useState("0.00");
  // const [salesMargin, setSalesMargin] = useState("0.00");
  const outletId = localStorage.getItem("outlet_id");
  const [totalQuantity, setTotalQuantity] = useState(0);
  const[cust, setCust] = useState(null)
console.log(salesMargin,"salesMargin");

  const dispatch = useDispatch();
  const [poDetails, setPoDetails] = useState({
    docDate: moment().format(),
    supplierId: null,
  });

  const getSupplierData = () => {
    axios
      .get(`/v1/outlet/list/1`)
      .then((res) => {
        _.filter(res.data,val=>val.id== outletId).map(val=>setCust(val))

        setSupplierData(res.data);
        console.log(res.data,"res.data");
        
      })
      .catch((err) => {
        console.log(err);
        dispatch(setSnackbar(true, 'error', err.response.data.error));
      });
  };
console.log(outletType,"salesMargin1");

  const handleSupplierChange = (event, value) => {
    const selectedSupplier = supplierData.find((supplier) => supplier.fullname === value?.fullname);
    setAddress(selectedSupplier ? `${selectedSupplier.add1} ${selectedSupplier.add2}, ${selectedSupplier.city_name}-${selectedSupplier.pincode}-${selectedSupplier.state_name}-${selectedSupplier.country_name}` : '');
    setGstIn(selectedSupplier ? selectedSupplier.gstin : "");
    setBalance(selectedSupplier ? selectedSupplier.balance : "0.00");
    setSalesMargin(selectedSupplier ? selectedSupplier.sales_margin : "0.00");
    setOutletType(selectedSupplier ? selectedSupplier.outlet_type_name : "");
    setPoDetails((prevState) => ({ ...prevState, supplierId: value }));
    setMode(value.outlet_type_name === "OWN" ? 'Transfer' : 'Sales');
    console.log(selectedSupplier,"selectedSupplier133");
    
    // Fetch outlet-based document number
    const postData = {
      outlet_id: value.id,
    };
    axios.post('/v1/sales_master/unique/docno/new', postData)
      .then((res) => {
        setDocName(res.data.Docno);
      })
      .catch((err) => {
        const errorMessage = err.response?.data?.errors?.[0]?.message || "Data Not Found";
        console.log(errorMessage);
        dispatch(setSnackbar(true, 'error', errorMessage));
      });
  };

  const handleChange = (e) => {
    setPoDetails((prevState) => ({ ...prevState, docDate: dayjs(e).format() }));
  };

  useEffect(() => {
    getSupplierData();
  }, []);

  useEffect(() => {
    if (poDetails.supplierId !== null) {
      setPostData((prev) => ({
        ...prev,
        docdate: moment(poDetails.docDate).format('YYYY/MM/DD'),
        mode: mode,
        partycode: poDetails.supplierId.id,
      }));
    }
  }, [poDetails, mode, setPostData]);
useEffect(() => {
    const total = data.reduce((sum, item) => sum + item.qty, 0);
    setTotalQuantity(total);
  }, [data]);
    // Set default supplier based on outletId
 // Set default supplier based on outletId
 useEffect(() => {
  if (outletId && supplierData.length) {
    const defaultSupplier = supplierData.find(supplier => supplier.id === parseInt(outletId));
    if (defaultSupplier) {
      setPoDetails(prevState => ({
        ...prevState,
        supplierId: defaultSupplier,
        docDate: moment().format(),
      }));
      setAddress(`${defaultSupplier.add1} ${defaultSupplier.add2}, ${defaultSupplier.city_name}-${defaultSupplier.pincode}-${defaultSupplier.state_name}-${defaultSupplier.country_name}`);
      setGstIn(defaultSupplier.gstin);
      setBalance(defaultSupplier.balance);
     setMode(defaultSupplier.outlet_type_name === "OWN" ? 'Transfer' : 'Sales');
   setOutletType(defaultSupplier.outlet_type_name);
   setSalesMargin(defaultSupplier.sales_margin);

      // Fetch the docno after setting default supplier
      const postData = {
        outlet_id: defaultSupplier.id,
      };
      axios.post('/v1/sales_master/unique/docno/new', postData)
        .then((res) => {
          if (res.data?.Docno) {
            // Log for debugging
            console.log("Fetched Docno on load:", res.data.Docno);
            setDocName(res.data.Docno);  // Set document number (docno) here
          } else {
            dispatch(setSnackbar(true, 'error', "Document number not found"));
          }
        })
        .catch((err) => {
          console.log(err);
          dispatch(setSnackbar(true, 'error', err.response?.data?.error || "Error fetching document number"));
        });
    }
  }
}, [outletId, supplierData]);
console.log(supplierData,"supplierData11");
console.log(poDetails,"poDetails25666");

  return (
    <Grid container spacing={2} className="p-2 h-full">
      <Grid item lg={4}>
        <Autocomplete
          id="supplier"
          name="supplier"
          size="small"
          options={supplierData}
          getOptionLabel={(option) => option?.fullname}
          value={poDetails.supplierId}
          onChange={handleSupplierChange}
          disableClearable
          isOptionEqualToValue={(option, value) => option.fullname === value.fullname}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Outlet Name"
              autoComplete="off"
            />
          )}
        />
        <TextField size="small" label="Address" multiline rows={3.3} fullWidth sx={{ marginBlock: 1.5 }} value={address} InputProps={{ readOnly: true }} />
        <TextField size="small" label="GSTIN" fullWidth value={gstIn} InputProps={{ readOnly: true }} />
       
      
    
      </Grid>
      <Grid item lg={4}>
        <TextField size="small" label="Bill No" fullWidth value={docName} InputProps={{ readOnly: true }} />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            onChange={(e) => handleChange(e)}
            value={dayjs(poDetails.docDate)}
            label="Bill Date"
            slotProps={{
              textField: {
                size: "small",
              },
            }}
            sx={{ width: '100%', marginBlock: 1.5 }}
          />
        </LocalizationProvider>
        <TextField size="small" label="Mode" fullWidth sx={{ marginBlock: 1.5 }} value={mode} />
     
      </Grid>
      <Grid item lg={4}>
        <Typography textAlign="center" variant="h6" sx={{ backgroundColor: '#83A2FF' }}>Balance</Typography>
        <Typography textAlign="right" variant="h5" mt={1} sx={{ fontWeight: 600 }}>{balance}</Typography>
        <Grid item style={{marginTop:"50px"}}>
        <Typography textAlign="center" variant="h6" sx={{ backgroundColor: '#83A2FF' }}>Total Quantity</Typography>
        <Typography textAlign="right" variant="h5" mt={1} sx={{ fontWeight: 600 }}>{totalQuantity}</Typography>
      </Grid>
      </Grid>
      {/* <Grid item lg={4}>
        <Typography textAlign="center" variant="h6" sx={{ backgroundColor: '#83A2FF' }}>Total Quantity</Typography>
        <Typography textAlign="right" variant="h5" mt={1} sx={{ fontWeight: 600 }}>{totalQuantity}</Typography>
      </Grid> */}
    </Grid>
  );
};

export default memo(SalesInfo);
